import React, { useEffect } from 'react'

import { useTranslation } from '@disco/i18n/use-translation'
import { clientLibraryListGetAll } from '@disco/state-management/actions/client-library-list-actions'
import { getArtistProfile } from '@disco/state-management/selectors/artist-profile'

import DocumentHeadTags from 'components/document-head-tags'
import { Spinner } from 'components/ds'
import ErrorPage from 'components/error-page'
import NotFoundPage from 'components/not-found-page'
import PageContainer from 'components/ui/page-container'
import PageHeader from 'components/ui/page-header'

import { useDispatch, useSelector } from 'hooks/use-redux'

const ArtistProfile = () => {
  const { t } = useTranslation('common')
  const dispatch = useDispatch()
  const loaded = useSelector(state => state.clientLibraries.libraries.loaded)
  const loading = useSelector(state => state.clientLibraries.libraries.loading)
  const error = useSelector(state => state.clientLibraries.libraries.error)
  const artistProfile = useSelector(getArtistProfile)

  useEffect(() => {
    if (!loaded && !loading) {
      dispatch(clientLibraryListGetAll({}))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (error && !loading && !loaded) {
    return <ErrorPage />
  }
  if (!loaded) {
    return <Spinner size="3" data-testid="artist-profile-spinner" />
  }

  if (!artistProfile) {
    return <NotFoundPage />
  }

  return (
    <div className="Page">
      <DocumentHeadTags
        title={t('common:artistProfileDisco', 'Artist Profile | DISCO')}
      />
      <div className="Page_Content">
        <PageHeader title={t('common:artistProfile', 'Artist Profile')} />
        <PageContainer>
          <PageContainer.Section
            title={t('common:manageArtistDetails', 'Manage artist details')}
          >
            <h2>{artistProfile.name}</h2>
          </PageContainer.Section>
          <PageContainer.Section
            title={t('common:manageTopTracks', 'Manage top tracks')}
          />
          <PageContainer.Section
            title={t('common:managePlaylists', 'Manage playlists')}
          />
          <PageContainer.Section
            title={t('common:manageVideos', 'Manage videos')}
          />
        </PageContainer>
      </div>
    </div>
  )
}

export default ArtistProfile
